import React from 'react';
import {IconProps} from "../services/IconConstants";

const StarSquareIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--text)'}
             style={style}
             className={className}
             fill={"none"}>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.75 2C3.23122 2 2 3.23122 2 4.75V19.75C2 21.2688 3.23122 22.5 4.75 22.5H19.75C21.2688 22.5 22.5 21.2688 22.5 19.75V4.75C22.5 3.23122 21.2688 2 19.75 2H4.75ZM13.4312 7.19832C12.9315 6.26723 11.5677 6.26722 11.068 7.19832L9.83204 9.50138L7.13056 9.90994C6.09836 10.066 5.57502 11.3457 6.40365 12.1346L8.31505 13.9546L7.89536 16.4848C7.70793 17.6148 8.90827 18.2971 9.80446 17.8635L12.2496 16.6807L14.6947 17.8635C15.5909 18.2971 16.7913 17.6148 16.6038 16.4848L16.1841 13.9546L18.0955 12.1346C18.9242 11.3457 18.4008 10.066 17.3686 9.90994L14.6671 9.50138L13.4312 7.19832Z"
                  fill="currentColor"/>
        </svg>
    );
}

export default StarSquareIcon;